
<div ref="terminal" class="flow-terminal" :data-scrollbar="showScrollbar" />
